import { useState } from 'react';

import { useRepository } from '@/Application/Providers/Repository';
import { saveShippingAddressCommune } from '@/modules/cart/application/saveShippingAddressCommune';
import type { ICommunePayload } from '@/modules/cart/domain/AddressCommune';
import type { MutatorHook } from '@/sections/shared/types/MutatorHook';

type Entity = ICommunePayload;

const useCreateShippingAddressCommune = (): MutatorHook<Entity> => {
  const { cart: cartRepository } = useRepository();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const trigger = async (address: Entity) => {
    setIsLoading(true);

    try {
      const res = await saveShippingAddressCommune(cartRepository, {
        commune: address.commune
      });

      if (!res) {
        throw new Error('Error al actualizar la dirección');
      }
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setIsLoading(false);
    }
  };

  return { trigger, isLoading, error };
};

export default useCreateShippingAddressCommune;
